import { createContext, useContext } from 'react';

interface ProviderStoreContextValue {
  providerId: string | undefined;
}

const ProviderStoreContext = createContext<ProviderStoreContextValue>({ providerId: undefined });

export const ProviderStoreProvider = ProviderStoreContext.Provider;

export const useProviderStoreContext = () => useContext(ProviderStoreContext);
